




























import Vue from 'vue'
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import PostApi from '../../plugins/AdminTemplate/includes/logic/Api/PostApi'
import FileDescriptorsPreview from '../File/FilesList/FileDescriptorsPreview.vue'
import { FileStatus, MediaFileData } from '../File/types'
import { MediaEditorMode } from '../NewMessageEditors/types'
import MediaUploader from './MediaUploader.vue'

@Component({
  data() {
    return {
      PostApi,
      MediaEditorMode
    }
  },
  components: {
    FileDescriptorsPreview,
    MediaUploader,
  }
})
export default class UploadMediaDescriptors extends Vue {
  @Prop() value!: Array<string>

  @Prop() targetId!: number | string

  @Emit()
  onFilesUpdate(descriptors: Array<string>) {
    return descriptors
  }

  localFiles: Array<string | MediaFileData> = []

  handleChanges(file: MediaFileData) {
    if (this.localFiles.length < 10) {
      this.localFiles.push(file)
    }
  }

  removeFile(descriptor: string):void {
    this.localFiles = this.localFiles.filter(d => typeof d === 'string' ? d !==descriptor : d.file !== descriptor)
  }

  @Watch('localFiles', { deep: true })
  onLocalFilesChange(files: Array<MediaFileData>) {
    this.onFilesUpdate(files.filter(f => f.file ? f.status === FileStatus.Uploaded : !!f).map(f => f?.file ?? f))
  }

  created() {
    this.localFiles = [ ...this.value ]
  }
}
